@if(visible()){
<div [ngStyle]="flexStyle" class="items-center"> <!-- class="jk-edit-border" -->
  <div>
    <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
      [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
  </div>
  <div class="w-full jk-margin0">
    <input matInput class="w-full" [(value)]="value" [readonly]="true" [ngStyle]="widthStyle">
  </div>
</div>
}